import React from "react";
import {
    convert_to_Thaidatetime,
    createMarkup,
    moment_datetime,
} from "../../../helpers/functions";
import { Link } from "react-router-dom";
import ShowFileDowload from "./ShowFileDowload";
import InterestedContent from "../../components/Utils/InterestedContent";

function ShowEbook({ data }) {
    return (
        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 min-h-screen">

            <div className="grid grid-cols-12 mt-2">
                <div className="col-span-12 md:col-span-12">
                    <h2 className="news-title font-medium text-base  md:text-lg lg:text-2xl text-gray-700">
                        {data.show && data.show.Question}
                    </h2>
                    <div className="news-header-line border-b-4 border-[#2F9DFF] pb-2">
                        <div className="item inline-block mr-5 text-gray-500 font-light">
                            <i className="fa fa-clock-o" />
                            &nbsp;{data.show && moment_datetime(data.show.Date)}
                        </div>
                        <div className="item inline-block mr-5 text-gray-500 font-light">
                            <i className="fa fa-eye" />
                            &nbsp;{data.show && data.show.pageview}
                        </div>
                    </div>
                    <iframe src={data.show && data.show.Note} className="w-full h-screen my-2 px-1" seamless="seamless" scrolling="no" allowtransparency="true" allowFullScreen="true" frameborder="0"></iframe>
                    <div className="">
                        <div className="row">
                            <div className="col-md-12">
                                {data.show && data.show.ndata && (
                                    <ShowFileDowload
                                        data={data.show}
                                        nlink={data.show.nlink}
                                    />
                                )}

                                <div className="news-picture-item">
                                    <div style={{ clear: "both" }} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 text-left"></div>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 md:col-span-3">
                    {/* <InterestedContent /> */}
                </div>
            </div>
        </div>
    );
}

export default ShowEbook;
